/* Contains the default layouts structure for each page */

import { v4 as uuid4 } from "uuid"
import { utils } from "@/store/helpers"
import { ALL_COMPONENTS } from "@/store/constants/all_components"
import store from "@/store"

const getPageDefaultLayout = (page_reference, sub_page_reference) => {
  let layout = null
  let slug = null
  let name = null

  // sub pages
  // sub pages for company profile and other objects are defined here (other objects have only three sub pages (overview,actions,checklists))
  switch (page_reference) {
    case "company_profile":
      if (sub_page_reference == "overview") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.OVERVIEW,
              component_reference: "company_profile_company_overview_company_details_component",
              component_props: {
                label: utils.ObjectType(sub_page_reference).plural_label + " " + window.$t("Details"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Overview")
      } else if (sub_page_reference == "insights") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.COMPANY_PROFILE_COMPANY_INSIGHTS,
              component_reference: uuid4(),
              component_props: {
                label: utils.ObjectType(sub_page_reference).plural_label + " " + window.$t("Insights")
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Insights")
      } else if (sub_page_reference == "map") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.COMPANY_MAP,
              component_reference: uuid4(),
              component_props: {
                label: utils.ObjectType(sub_page_reference).plural_label + " " + window.$t("Map"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Company Map")
      } else if (sub_page_reference == "actions") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 24,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.ACTIONS_TABLE,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Activities"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Activities")
      } else if (sub_page_reference == "checklists") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.CHECKLIST,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Checklists"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Checklists")
      } else {
        // else sub_page_reference is a nested object_type
        // check if it is a object type from the list of object types in the store
        if (store.state.object_types.find((object_type) => object_type.type == sub_page_reference)) {
          layout = [
            {
              h: 48,
              w: 72,
              x: 0,
              y: 0,
              minW: 24,
              minH: 24,
              is_static: true,
              fixed: true,
              id: uuid4(),
              moved: false,
              props: {
                component_type: ALL_COMPONENTS.OBJECT_TABLE,
                component_reference: uuid4(),
                component_props: {
                  label: `${utils.ObjectType(sub_page_reference).plural_label} ` + window.$t("Table"),
                  objectType: sub_page_reference,
                  connectTo: "this_record"
                }
              }
            }
          ]
          slug = sub_page_reference
          name = utils.ObjectType(sub_page_reference).plural_label
        } else {
          // return null if sub_page_reference is not a nested object_type
          // to prevent creating un unwanted layouts
          layout = null
        }
      }
      break
    // All the other objects have only three sub pages (overview,actions,checklists)

    case "contact_profile":
      if (sub_page_reference == "overview") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.OVERVIEW,
              component_reference: uuid4(),
              component_props: {
                label: utils.ObjectType(sub_page_reference).plural_label + " " + window.$t("Details"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Overview")
      } else if (sub_page_reference == "actions") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 24,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.ACTIONS_TABLE,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Activities"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Activities")
      } else if (sub_page_reference == "checklists") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.CHECKLIST,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Checklists"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Checklists")
      } else {
        if (store.state.object_types.find((object_type) => object_type.type == sub_page_reference) && sub_page_reference != "company") {
          layout = [
            {
              h: 48,
              w: 72,
              x: 0,
              y: 0,
              minW: 24,
              minH: 24,
              is_static: true,
              fixed: true,
              id: uuid4(),
              moved: false,
              props: {
                component_type: ALL_COMPONENTS.OBJECT_TABLE,
                component_reference: uuid4(),
                component_props: {
                  label: `${utils.ObjectType(sub_page_reference).plural_label} ` + window.$t("Table"),
                  objectType: sub_page_reference,
                  connectTo: "this_record"
                }
              }
            }
          ]
          slug = sub_page_reference
          name = utils.ObjectType(sub_page_reference).plural_label
        } else {
          // return null if sub_page_reference is not a nested object_type
          // to prevent creating un unwanted layouts
          layout = null
        }
      }
      break

    default:
      if (sub_page_reference == "overview") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.OVERVIEW,
              component_reference: uuid4(),
              component_props: {
                label: utils.ObjectType(sub_page_reference).plural_label + " " + window.$t("Details"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Overview")
      } else if (sub_page_reference == "actions") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 24,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.ACTIONS_TABLE,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Activities"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Activities")
      } else if (sub_page_reference == "checklists") {
        layout = [
          {
            id: uuid4(),
            w: 72,
            x: 0,
            y: 0,
            h: 48,
            fixed: true,
            props: {
              component_type: ALL_COMPONENTS.CHECKLIST,
              component_reference: uuid4(),
              component_props: {
                label: window.$t("Checklists"),
                connectTo: "this_record"
              }
            }
          }
        ]
        slug = sub_page_reference
        name = window.$t("Checklists")
      } else {
        if (store.state.object_types?.find((object_type) => object_type.type == sub_page_reference) && sub_page_reference != "company") {
          layout = [
            {
              h: 48,
              w: 72,
              x: 0,
              y: 0,
              minW: 24,
              minH: 24,
              is_static: true,
              fixed: true,
              id: uuid4(),
              moved: false,
              props: {
                component_type: ALL_COMPONENTS.OBJECT_TABLE,
                component_reference: uuid4(),
                component_props: {
                  label: `${utils.ObjectType(sub_page_reference).plural_label} ` + window.$t("Table"),
                  objectType: sub_page_reference,
                  connectTo: "this_record"
                }
              }
            }
          ]
          slug = sub_page_reference
          name = utils.ObjectType(sub_page_reference).plural_label
        } else {
          // return null if sub_page_reference is not a nested object_type
          // to prevent creating un unwanted layouts
          layout = null
        }
      }
      break
  }

  return [layout, name, slug]
}

export default getPageDefaultLayout
